module.exports = __webpack_public_path__ + "static/media/mini.7c943d27.png";